var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 4.7998C12.3315 4.7998 12.6001 5.06843 12.6001 5.3998V18.5998C12.6001 18.9312 12.3315 19.1998 12.0001 19.1998C11.6687 19.1998 11.4001 18.9312 11.4001 18.5998V5.3998C11.4001 5.06843 11.6687 4.7998 12.0001 4.7998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60012 12.9598C3.20248 12.9598 2.88012 12.6375 2.88012 12.2398C2.88012 11.8422 3.20248 11.5198 3.60012 11.5198H7.69252L5.62108 9.6388C5.33445 9.36319 5.32551 8.9074 5.60112 8.62077C5.87673 8.33413 6.33252 8.32519 6.61916 8.60081L9.97916 11.7208C10.1203 11.8566 10.2001 12.044 10.2001 12.2398C10.2001 12.4357 10.1203 12.6231 9.97916 12.7588L6.61916 15.8788C6.33252 16.1544 5.87673 16.1455 5.60112 15.8588C5.32551 15.5722 5.33445 15.1164 5.62108 14.8408L7.69252 12.9598H3.60012Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4003 12.9598C20.7979 12.9598 21.1203 12.6375 21.1203 12.2398C21.1203 11.8422 20.7979 11.5198 20.4003 11.5198H16.3079L18.3793 9.6388C18.666 9.36319 18.6749 8.9074 18.3993 8.62077C18.1237 8.33413 17.6679 8.32519 17.3813 8.60081L14.0213 11.7208C13.8801 11.8566 13.8003 12.044 13.8003 12.2398C13.8003 12.4357 13.8801 12.6231 14.0213 12.7588L17.3813 15.8788C17.6679 16.1544 18.1237 16.1455 18.3993 15.8588C18.6749 15.5722 18.666 15.1164 18.3793 14.8408L16.3079 12.9598H20.4003Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignMiddle);
export default __webpack_public_path__ + "static/media/align-middle.863acda342fbd3fd63aeaac6bdc132f4.svg";
export { ForwardRef as ReactComponent };